import { render, staticRenderFns } from "./TTLEditor.vue?vue&type=template&id=54a2208c&scoped=true"
import script from "./TTLEditor.vue?vue&type=script&lang=js"
export * from "./TTLEditor.vue?vue&type=script&lang=js"
import style0 from "./TTLEditor.vue?vue&type=style&index=0&id=54a2208c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a2208c",
  null
  
)

export default component.exports